import {http} from '@/utils';
import {
  RecordListItem,
  RecordListParams,
  UserDetailListParams,
  UserListItem,
  UserTotal,
} from './invitation.type';
import {PageParams, PageResponse, SafeAny} from '@/types';

export interface InviteCodeValidationResult {
  valid?: boolean;
  status?: string;
  message?: string;
}

// 邀请页不携带登录态，必须显式跳过 token 注入。
export function validateInviteCode(inviteCode: string) {
  return http.post<
    {inviteCode: string; skipToken: true},
    InviteCodeValidationResult
  >('app/user/invite-code:validate', {inviteCode, skipToken: true});
}

// 获取当前用户邀请任务列表
export function getUserList() {
  return http.get<null, UserListItem[]>('app/inviteTask/getUserList');
}

// 获取当前用户邀请记录列表
export function getRecordList(params: RecordListParams) {
  return http.post<RecordListParams, PageResponse<SafeAny>>(
    'app/inviteTask/getRecordList',
    params,
  );
}

// 获取任务详细用户数据列表
export function getTaskDetailList(params: UserDetailListParams) {
  return http.post<UserDetailListParams, PageResponse<RecordListItem>>(
    'app/inviteTask/getTaskDetailList',
    params,
  );
}

// 获取当前用户邀请任务人数和奖金总数
export function getUserTotal() {
  return http.get<null, UserTotal>('app/inviteTask/getUserTotal');
}

export interface InviteTotal {
  totalBonusAmount: number;
  totalInvitedCount: number;
}

// 新-邀请总计信息
export function getInviteTotal() {
  return http.get<null, InviteTotal>('app/inviteRecharge/userInfo');
}

export interface DateRangeDetailParams {
  startDate: string;
  endDate: string;
}

export interface DateRangeDetailResponse {
  newUserCountTotal: number;
  rechargeTotalAmount: number;
  rechargeTotalBonusAmount: number;
  rechargeUserCount: number;
}

export function dateRangeDetail(data: DateRangeDetailParams) {
  return http.post<DateRangeDetailParams, DateRangeDetailResponse>(
    'app/inviteRecharge/dateRangeDetail',
    data,
  );
}

export interface RuleParams {
  bonusRate: number;
  invitedUserDepositMin: number;
}

export function getRuleParams() {
  return http.get<null, RuleParams>('app/inviteRecharge/inviteRule');
}

export interface RecordListV2Params extends PageParams {
  startDate: string;
  endDate: string;
}

export interface RecordListV2Item {
  bonusAmount?: number;
  invitedUserAvatar?: string;
  invitedUserId?: number;
  invitedUserName?: string;
  invitedUserPhone?: string;
  rechargeAmount?: number;
}

export function getRecordListV2(params: RecordListV2Params) {
  return http.post<RecordListV2Params, PageResponse<RecordListV2Item>>(
    'app/inviteRecharge/recordList',
    params,
  );
}
